<div style="max-width:1000px;margin:15px 0;">
  <h3>Manage Tax Rate Set</h3>
  <h5>Select a Tax Rate Set to manage Tax Agencies.</h5>
  <form #manageTaxRateForm="ngForm">
    <p *ngIf="errMesgForRepeatedSalesTaxRate&&errMesgForRepeatedSalesTaxRate.length>1" class="growl-submit">{{errMesgForRepeatedSalesTaxRate}}</p>
    <div class="p-grid">
      <div *ngIf="salesTaxRateObject" class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label> Name*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText name="name" type="text" style="width:200px!important;"
                   [(ngModel)]="salesTaxRateObject.name"
                   (blur)="getSalesTaxRateNameUniqueness(salesTaxRateObject.name, salesTaxRateObject.id)"
                   required>
          </div>

          <div class="p-col-12 p-md-4 p-lg-4">
            <label> Rate Type*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown name="rateType" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{'min-width':'200px'}"
                        [options]="taxRateTypeDropdown"
                        [(ngModel)]="salesTaxRateObject.taxRateType" required></p-dropdown>
          </div>

          <div class="p-col-12 p-md-4 p-lg-4">
            <label> Description*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
          <textarea pInputTextarea name="desc" [rows]=textareaDefaultRow [cols]=textareaDefaultColumn style="height:75px !important;"
                    [(ngModel)]="salesTaxRateObject.description"
                    required></textarea>
          </div>
        </div>
      </div>
    </div>

  </form>
</div>


<div>

  <app-data-table [columns]="tableColumns" [value]="salesTaxRateObject?.salesTaxRateItems"
                  [captionTemplate]="taxRateCaption" [bodyTemplate]="taxRateBody" [footerTemplate]="taxRateFooter">

    <ng-template #taxRateCaption>
      <div class="p-grid">
        <div class="p-col-12" style="text-align:right;">
          <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="Add Tax Agency" style="float:right;"
                  (click)="showAddTaxDialog()"
                  [disabled]="salesTaxRateObject.taxRateType===SalesTaxRateType.Single && salesTaxRateObject.salesTaxRateItems.length>=1 || errMesgForRepeatedSalesTaxRate?.length > 0">
          </button>
        </div>
      </div>
    </ng-template>


    <ng-template #taxRateBody let-row="row" let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" [ngSwitch]="col.field">
          <span class="p-column-title">{{col.header}}</span>
          <span class="p-cell">
            <div *ngSwitchCase="'agencyTaxRate'">
              {{row.salesTaxAgency?.salesTaxDates[0]?.agencyTaxRate}}%
            </div>
            <div *ngSwitchCase="'effectiveDate'">
              {{row.salesTaxAgency?.salesTaxDates[0]?.effectiveDate | date:Format.Date}}
            </div>
            <div *ngSwitchCase="'action'">
              <button pButton type="button" class="icon-button icon-action" icon="fa fa-pencil" pTooltip="Edit" tooltipPosition="top"
                      (click)="showEditAgency(row)">
              </button>
              <button pButton type="button" class="icon-button icon-negative" icon="fa fa-trash-o" pTooltip="Delete" tooltipPosition="top"
                      (click)="deleteAgency(row)">
              </button>
            </div>
            <div *ngSwitchDefault>
              <app-data-table-renderer [col]="col" [row]="row"></app-data-table-renderer>
            </div>
          </span>
        </td>
      </tr>
    </ng-template>

    <ng-template #taxRateFooter>
      <tr>
        <td [style]="{'text-align':'right','font-weight':'bold'}">
          Total
        </td>
        <td>
          <span style="float:left;font-weight:bold;"> {{totalRate}}%</span>
        </td>
      </tr>
    </ng-template>
  </app-data-table>
  <div style="text-align: right;margin-bottom:25px;margin-top:20px;">
    <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel" (click)="onCancel()">
    </button>
    <button pButton type="button" class="button-action" icon="fa fa-check"
            label="Save" (click)="onSave()" [disabled]="!manageTaxRateForm.form.valid ||salesTaxRateObject.salesTaxRateItems.length<1 || errMesgForRepeatedSalesTaxRate?.length > 0">
    </button>


  </div>
</div>

<p-dialog *ngIf="salesTaxAgencyDialog" [(visible)]="salesTaxAgencyDialog" header="Add or Modify Tax Agency" [responsive]="true" [modal]="true"
          [style]="PrimeNgConfig.DialogStyle40">
  <form #addTaxAgency="ngForm">
    <p *ngIf="errMesgForRepeatedSalesTaxAgency&&errMesgForRepeatedSalesTaxAgency.length>1" class="growl-submit">{{errMesgForRepeatedSalesTaxAgency}}</p>
    <div class="p-grid">
      <div class="p-col-12 p-lg-4">
        <label>Agency Name*</label>
      </div>
      <div class="p-col-12 p-lg-7">
        <input pInputText name="name" type="text" style="width:210px!important;" [(ngModel)]="salesTaxRateItem.salesTaxAgency.taxAgency"
               (blur)="getSalesTaxAgencyUniqueness(salesTaxRateItem.salesTaxAgency.taxAgency, salesTaxRateItem.salesTaxAgency.id)"
               required>
      </div>
      <div class="p-col-12 p-lg-4">
        <label>Description*</label>
      </div>
      <div class="p-col-12 p-md-7 p-lg-7">
        <textarea pInputText pInputTextarea name="desc" [rows]=textareaDefaultRow [cols]=textareaDefaultColumn style="height:75px !important;"
                  [(ngModel)]="salesTaxRateItem.salesTaxAgency.description" required></textarea>
      </div>

      <div *ngIf="!salesTaxRateItem.salesTaxAgency.id" class="p-col-12 p-lg-4">
        <label>Effective Date*</label>
      </div>
      <div *ngIf="!salesTaxRateItem.salesTaxAgency.id" class="p-col-12 p-lg-7">
        <p-calendar name="date" dataType="string" [dateFormat]="Format.PcalendarDate" [maxDate]="maxDate" [showIcon]="true"
                    [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange" [style]="{'overflow':'visible'}"
                    [(ngModel)]="salesTaxRateItem.salesTaxAgency.salesTaxDates[0].effectiveDate"
                    (onSelect)="onSelectEffectiveDate(salesTaxRateItem.salesTaxAgency.salesTaxDates[0].effectiveDate)" required></p-calendar>
      </div>


      <div *ngIf="salesTaxRateItem.salesTaxAgency.id" class="p-col-12 p-lg-4">
        <label>Effective Date*</label>
      </div>
      <div *ngIf="salesTaxRateItem.salesTaxAgency.id" class="p-col-12 p-lg-7">
        <p-calendar name="date" dataType="string" [dateFormat]="Format.PcalendarDate" [showIcon]="true"
                    [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange" [style]="{'overflow':'visible'}"
                    [(ngModel)]="salesTaxRateItem.salesTaxAgency.salesTaxDates[0].effectiveDate"
                    (onSelect)="onSelectEffectiveDate(salesTaxRateItem.salesTaxAgency.salesTaxDates[0].effectiveDate)" required></p-calendar>
      </div>

      <div class="p-col-12 p-lg-4">
        <label>Tax Rate*</label>
      </div>
      <div class="p-col-12 p-lg-7">
        <span class="p-inputgroup">
          <input pInputText name="rate" type="string" [pattern]="RegExp5DigitDecimal" style="width:210px!important;"
                 [(ngModel)]="salesTaxRateItem.salesTaxAgency.salesTaxDates[0].agencyTaxRate" required #agencyTaxRate="ngModel">
          <span class="p-inputgroup-addon">%</span>
        </span>
        <div *ngIf="agencyTaxRate.invalid && (agencyTaxRate.dirty || agencyTaxRate.touched)" class="alert alert-danger">
          Tax rate must be a decimal number between 0 and 100 with up to 5 digits after the decimal point.
        </div>
      </div>

      <div class="p-col-12 p-lg-4">
        <label>Payment Type*</label>
      </div>
      <div class="p-col-12 p-lg-7">
        <p-dropdown name="taxPaymentType" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{'width':'210px'}"
                    [options]="taxPaymentTypeDropDown"
                    [(ngModel)]="salesTaxRateItem.salesTaxAgency.taxPaymentType" required></p-dropdown>
      </div>
      <div class="p-col-12 p-lg-4">
        <label>Compliance Schedule*</label>
      </div>
      <div class="p-col-12 p-lg-7">
        <p-dropdown name="calendarId" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{'width':'210px'}"
                    [options]="startOnDropdown"
                    [(ngModel)]="salesTaxRateItem.salesTaxAgency.calendarId"
                    (onChange)="onChangeComplianceSchedule(salesTaxRateItem.salesTaxAgency.calendarId)"
                    required></p-dropdown>
      </div>

    </div>
  </form>
  <p-footer>
    <div class="p-col-12" style="text-align:right;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close"
              (click)="salesTaxAgencyDialog = false"></button>
      <button *ngIf="!salesTaxRateItem.salesTaxAgency.id" pButton type="button" class="button-action" icon="fa fa-check" label="Add"
              (click)="saveSalesTaxRateItem()"
              [disabled]="!addTaxAgency.form.valid || errMesgForRepeatedSalesTaxAgency?.length > 0"></button>
      <button *ngIf="salesTaxRateItem.salesTaxAgency.id" pButton type="button" class="button-action" icon="fa fa-check" label="Update"
              (click)="updateAgency(salesTaxRateItem)"
              [disabled]="!addTaxAgency.form.valid || errMesgForRepeatedSalesTaxAgency?.length > 0"></button>

    </div>
  </p-footer>
</p-dialog>
